import { DEFINITIONS_EDITOR_ACTIONS } from '@mode/legacy/util-domain';

export { DEFINITIONS_EDITOR_ACTIONS };

export const runDefinition = () => ({
  type: DEFINITIONS_EDITOR_ACTIONS.RunDefinition,
});

export const runDefinitionFulfilled = (canceled: boolean, failed: boolean) => ({
  type: DEFINITIONS_EDITOR_ACTIONS.RunDefinitionFulfilled,
  canceled,
  failed,
});

export const toggleVerticalMode = () => ({
  type: DEFINITIONS_EDITOR_ACTIONS.ToggleVerticalMode,
});

export const selectDefinition = (definition) => ({
  type: DEFINITIONS_EDITOR_ACTIONS.SelectDefinition,
  definition,
});

export const maximizeBottom = () => ({
  type: DEFINITIONS_EDITOR_ACTIONS.MaximizeBottom,
});

export const minimizeBottom = () => ({
  type: DEFINITIONS_EDITOR_ACTIONS.MinimizeBottom,
});

export const maximizeTop = () => ({
  type: DEFINITIONS_EDITOR_ACTIONS.MaximizeTop,
});

export const minimizeTop = () => ({
  type: DEFINITIONS_EDITOR_ACTIONS.MinimizeTop,
});

export const selectSecondaryTab = (tab: string) => ({
  type: DEFINITIONS_EDITOR_ACTIONS.SelectSecondaryTab,
  tab,
});
